import { render, staticRenderFns } from "./InputGeneric.vue?vue&type=template&id=0b9bf964&scoped=true&lang=pug"
import script from "./InputGeneric.vue?vue&type=script&lang=js"
export * from "./InputGeneric.vue?vue&type=script&lang=js"
import style0 from "./InputGeneric.vue?vue&type=style&index=0&id=0b9bf964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9bf964",
  null
  
)

export default component.exports